import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  selected: {},
  isLoaded: false,
  newAppointment: {
    date: "",
    specialtyId: ""
  }
};

const patientSlice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    setPatients: (state, { payload }) =>
    {
      state.list = payload;
      state.isLoaded = true;
    },
    addPatientToList: (state, { payload }) =>
    {
      state.list =  [...state.list, payload] ;
    },
    clearPatients: (state) =>
    {
      state.list = [];
    },
    setSelectedPatient: (state, { payload }) =>
    {
      state.selected = payload;
    },
    clearSelectedPatient: (state, { payload }) =>
    {
      state.selected = {}
     },
    updatePatientList: (state, { payload }) =>
    {
      state.list = state.list.map(item => item.id === payload.id ? {
        ...item,
        countryCode: item.countryCode,
        email: item.email,
        firstName: payload.firstName,
        lastName: payload.lastName,
        gender: payload.gender,
        phoneNumber: item.phoneNumber
      } : item);
    },
    removePatientFromList: (state, { payload }) =>
    {
      state.list = state.list.filter(item => item.id !== payload);
    },
    setNewAppointment: (state, { payload }) =>
    {
      state.newAppointment = payload
    }
  },
});

export const { setPatients, clearPatients, addPatientToList, updatePatientList, removePatientFromList, clearSelectedPatient, setSelectedPatient, setNewAppointment } = patientSlice.actions;
export default patientSlice.reducer;
